import React, { useEffect, useState } from 'react';

const FlyingBirds = ({ triggerFlight }) => {
  const [birds, setBirds] = useState([]);

  useEffect(() => {
    if (triggerFlight > 0) {
      // Create 7 birds with different delays and positions
      const newBirds = Array.from({ length: 7 }, (_, i) => ({
        id: `bird-${triggerFlight}-${i}`,
        delay: i * 0.2,
        top: `${45 + (i - 3) * 5}%`,
      }));
      setBirds(newBirds);

      // Clear birds after animation completes
      setTimeout(() => {
        setBirds([]);
      }, 5000);
    }
  }, [triggerFlight]);

  return (
    <div className="birds-container">
      {birds.map((bird) => (
        <div
          key={bird.id}
          className="bird"
          style={{
            top: bird.top,
            animationDelay: `${bird.delay}s`,
          }}
        >
          <svg width="40" height="30" viewBox="0 0 40 30" fill="none">
            <path
              d="M5 15 L15 5 L15 25 L5 15Z M25 5 L35 15 L25 25 L25 5Z"
              fill="#ffb2d7"
            />
          </svg>
        </div>
      ))}
    </div>
  );
};

export default FlyingBirds;
